import styled from '@emotion/styled';

const FilesWrapper = styled('ul')({
  marginTop: 16,
  marginBottom: -8,
  paddingLeft: 0,
  listStyle: 'none',
  display: 'flex',
  flexWrap: 'wrap',
});

export default FilesWrapper;
